// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import LectureLessonStatusModel from '../../model/lecture-lesson-status-model';
import LectureLessonStatusDTO from '../dto/lecture-lesson-status-dto';
import dtoSchema from '../schemas/lecture-lesson-status-schema';
import ResourceLinkModel from '../../model/resource-link-model';

export default abstract class LectureLessonStatusModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<LectureLessonStatusDTO>) {
    super();
    if (data) {
      this.id = data.id;
      this.links = data.links?.map((i) => ResourceLinkModel.toModel(i)) ?? [];
      this.toccoId = data.toccoId;
      this.toccoUniqueId = data.toccoUniqueId ?? undefined;
      this.name = data.name ?? undefined;
      this.htmlColor = data.htmlColor ?? undefined;
    }
  }
  /**
  * @type {int64}
  */
  id?: number;
  /**
  */
  links?: ResourceLinkModel[];
  /**
  * @type {int64}
  */
  toccoId?: number;
  /**
  */
  toccoUniqueId?: string;
  /**
  */
  name?: string;
  /**
  */
  htmlColor?: string;

  static toModel(dto: DeepPartial<LectureLessonStatusDTO>): LectureLessonStatusModel;
  static toModel(dto: DeepPartial<LectureLessonStatusDTO> | undefined | null): LectureLessonStatusModel | undefined;
  static toModel(dto: DeepPartial<LectureLessonStatusDTO> | undefined | null): LectureLessonStatusModel | undefined {
    return dto ? new LectureLessonStatusModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<LectureLessonStatusModel> | LectureLessonStatusModel): LectureLessonStatusDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      id: unwrapped.id,
      links: unwrapped.links,
      toccoId: unwrapped.toccoId,
      toccoUniqueId: unwrapped.toccoUniqueId,
      name: unwrapped.name,
      htmlColor: unwrapped.htmlColor,
    } as LectureLessonStatusDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for LectureLessonStatusModel, can not map to LectureLessonStatusDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
